var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SurveyQuestionInput',{attrs:{"identifier":_vm.identifier,"index":_vm.index,"question":_vm.question,"is-required-answer":_vm.isRequiredAnswer,"default-input-type":"text","legacy-options-mode":"buttons"},on:{"question-response":function($event){return _vm.$emit('question-response', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }